/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const locationOverviewNodes = document.querySelectorAll('.location-overview');

if (locationOverviewNodes.length > 0) {
    import(/* webpackChunkName: "LocationOverview" */ './components/LocationOverview').then(({default: LocationOverview}) => {
        [...locationOverviewNodes].forEach((node) => render(<LocationOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
